import { render } from "./GroupSchedule.vue?vue&type=template&id=79b29fb5&scoped=true"
import script from "./GroupSchedule.vue?vue&type=script&lang=js"
export * from "./GroupSchedule.vue?vue&type=script&lang=js"

import "./GroupSchedule.vue?vue&type=style&index=0&id=79b29fb5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b29fb5"]])

export default __exports__